import { Flex } from '@chakra-ui/react';
import { Layout } from 'src/components/Layout';
import StepHeader from 'src/pages/Organization/public/Journal/SubmissionUpload/components/StepHeader';
import ComposeEmail from '../../../EmailModule';
import { useQuery } from '@tanstack/react-query';
import { getAllTemplatesByCommand } from '../../../../api/email-service';
import { useSubmissionData } from '../../../../contexts/SubmissionDataProvider';

interface Props {
  currentStep: number;
  totalSteps: number;
  emails?: string[];
  attachments?: any[];
}

const ComposeAdjudicatorInvitation = ({
  currentStep,
  totalSteps,
  emails = [],
  attachments = []
}: Props) => {
  const { organizationId, submissionContextId } = useSubmissionData();
  const command = 'RequestAdjudication';
  const { data: emailTemplates } = useQuery({
    queryKey: ['browse-expert-templates', organizationId, command, submissionContextId],
    queryFn: () =>
      getAllTemplatesByCommand({
        organizationId,
        commandName: command,
        query: { submissionContextId }
      }),
    enabled: !!organizationId
  });

  return (
    <Layout width="960px">
      <Flex flexDirection="column" gap={8}>
        <StepHeader
          currentStep={currentStep}
          totalSteps={totalSteps}
          heading="Compose Invitation"
          description="Use the default template to invite Experts, or customize the invitation's subject, personal, and journal information. Submission details are always included automatically"
          marginY={0}
        />
        <ComposeEmail
          emailTemplates={emailTemplates?.data}
          emails={emails}
          attachments={attachments}
        />
      </Flex>
    </Layout>
  );
};

export default ComposeAdjudicatorInvitation;
